import { HttpResponse } from '@angular/common/http';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { AgenciasService } from 'src/app/_services/agencias.service';
import { ToursService } from 'src/app/_services/tours.service';

@Component({
  selector: 'app-tours-admin',
  templateUrl: './tours-admin.component.html',
  styleUrls: ['./tours-admin.component.css']
})
export class ToursAdminComponent implements OnInit, OnDestroy {

  subscription: Subscription;
  form: FormGroup;
  listTours = [];
  listPacks = [];
  cantidadTours: number;
  imagenTour: string;
  imagenDefault = '../assets/images/body/tours/01.jpg';
  idPaquete: Number;
  listaReservaciones = [];
  //existeImg = false;

  constructor(
    private modalService: NgbModal,
    private agenciasService:AgenciasService,
    private formBuilder: FormBuilder,
    private tourservice: ToursService,
    private router: Router,
  ) { }

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      search: [''],     
    });
    //*** cargar listado de tours reservados
    //this.toursReservados();
    //this.reservaciones();
    this.paquetesConReservacion()

    this.subscription = this.tourservice.paqueteReservado.subscribe(result => {
      this.idPaquete = result;
    });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  actualizarIdPaquete(id_paquete) {    
    this.idPaquete = id_paquete;
    this.tourservice.changePaqueteId(this.idPaquete);
    //console.log("el paquete que se toco es:  "+id_paquete);
    this.router.navigate(['/admin/tours-agencias']);
  }

  toursReservados(){  
    this.listTours = [];
    this.agenciasService.toursReservados().subscribe(data => {
      if(data instanceof HttpResponse) {
        if(data.body !== null && data.body !== undefined && data.body !== ''){
          //console.log(data.body[1]);
          this.cantidadTours = data.body.length;
          this.listTours = data.body; 
        }
        //console.log("cantidad de tours:  " + this.cantidadTours);  
        //console.log(this.listTours);   
      }    
    });    
  }

  reservaciones(){  
    this.listaReservaciones = [];
    this.agenciasService.reservacionesXPasajeroNC().subscribe(data => {
      if(data instanceof HttpResponse) {
        if(data.body !== null && data.body !== undefined && data.body !== ''){
          this.listaReservaciones = data.body;

          this.listaReservaciones.forEach(element => {
            var pack = element.id_paquete.id;

            this.agenciasService.UntourReservado(pack).subscribe(data => {
              if(data instanceof HttpResponse){
                if(data.body !== null && data.body !== undefined && data.body !== ''){
                  var packrecibido = data.body[0];
                  var imgrecibida = packrecibido.imagen; 
                  element.imagen = imgrecibida; 
                }
              }
            });
          });
        }//console.log(this.listaReservaciones);
      }    
    });    
  }

  paquetesConReservacion(){
    this.listPacks = [];
    this.agenciasService.viajesReservados('1').subscribe(data => {
      if(data instanceof HttpResponse){
        if(data.body !== null && data.body !== undefined && data.body !== ''){
          this.listPacks = data.body.list; console.log(this.listPacks);
        }
      }
    });
  }

}
